export default {
	es: {
		enlaces : {
			login : '/login',
			restablecer_login : '/restablecer-tutor',
			validaciones : '/validaciones',
			asignaciones : '/asignaciones',
			asignaciones_historico : '/asignaciones_historico',
			evaluaciones : "/evaluaciones",
			tutorados : "/tutorados",
			tutorados_historico : "/tutorados_historico",
			seguimiento_comunicaciones : "/seguimiento_comunicaciones",
			seguimiento_encuestas : "/seguimiento_encuestas",
			ofertas_tutor : "/ofertas_tutor",
			ficha : "/ficha",
			encuesta : '/encuesta',
			encuestas : '/encuestas',
			acceso : '/acceso',
			miperfil :'/mi-perfil',
			"1" : "pendientes",
			"2" : "validadas",
			"3" : "rechazadas",
			static: '/static'
		},
		encabezado : {
			home : 'Bienvenid@',
			politica_privacidad : "Política de privacidad",
			politica_cookies : "Política de cookies",
			login : "Inicio de sesión",
			documentacion : 'Documentación',
			restablecer_login : 'Restablecer Contraseña',
			encuesta : 'Encuesta',
			acceso : 'Acceso'
		},
	},
	en: {
		enlaces : {
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js